import PropTypes from 'prop-types';
import { useCallback } from 'react';
// @mui
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
// components
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Iconify from 'src/components/iconify';
import CustomDateRangePicker, {
  shortDateLabel,
} from 'src/components/custom-date-range-picker';

// ----------------------------------------------------------------------

export default function ReportsTableToolbar({
  filters,
  openDateRange,
  onCloseDateRange,
  onOpenDateRange,
  dateError,
  onFilters,
}) {
  const handleFilterTitle = useCallback(
    event => {
      onFilters('title', event.target.value);
    },
    [onFilters],
  );

  const handleFilterStartDate = useCallback(
    newValue => {
      onFilters('startDate', newValue);
    },
    [onFilters],
  );

  const handleFilterEndDate = useCallback(
    newValue => {
      onFilters('endDate', newValue);
    },
    [onFilters],
  );

  const useStyles = makeStyles(theme => ({
    button: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontWeight: 400,
      color: '#637381',
      whiteSpace: 'nowrap',
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      width: '200px',
      padding: '14px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      },
    },
    buttonText: {
      marginRight: theme.spacing(1),
    },
  }));

  const classes = useStyles();

  const renderFilterDate = (
    <>
      <Button
        color="inherit"
        variant="outlined"
        className={classes.button}
        onClick={onOpenDateRange}
        endIcon={
          <Iconify
            icon={
              openDateRange
                ? 'eva:arrow-ios-upward-fill'
                : 'eva:arrow-ios-downward-fill'
            }
            sx={{ ml: -0.5 }}
          />
        }
      >
        {!!filters.startDate && !!filters.endDate
          ? shortDateLabel(filters.startDate, filters.endDate)
          : 'Select Date Range'}
      </Button>

      <CustomDateRangePicker
        variant="calendar"
        startDate={filters.startDate}
        endDate={filters.endDate}
        onChangeStartDate={handleFilterStartDate}
        onChangeEndDate={handleFilterEndDate}
        open={openDateRange}
        onClose={onCloseDateRange}
        selected={!!filters.startDate && !!filters.endDate}
        error={dateError}
      />
    </>
  );

  return (
    <Stack
      spacing={2}
      alignItems={{ xs: 'flex-end', md: 'center' }}
      direction={{
        xs: 'column',
        md: 'row',
      }}
      sx={{
        p: 2.5,
        pr: { xs: 2.5, md: 1 },
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'flex-end', md: 'center' }}
        spacing={2}
        flexGrow={1}
        sx={{ width: 1 }}
      >
        <TextField
          sx={{
            width: { xs: 1, md: 260 },
          }}
          value={filters.candidate}
          onChange={handleFilterTitle}
          placeholder="Search title"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify
                  icon="eva:search-fill"
                  sx={{ color: 'text.disabled' }}
                />
              </InputAdornment>
            ),
          }}
        />
        <Stack
          spacing={1}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          flexGrow={1}
        >
          {renderFilterDate}
        </Stack>
      </Stack>
    </Stack>
  );
}

ReportsTableToolbar.propTypes = {
  filters: PropTypes.object,
  onFilters: PropTypes.func,
  openDateRange: PropTypes.any,
  onCloseDateRange: PropTypes.func,
  onOpenDateRange: PropTypes.func,
  dateError: PropTypes.any,
};
